angular
  .module 'gym.components'
  .directive 'reviewAffectedBookings', () ->
    restrict: 'E'
    template: require('templates/components/profile/reviewAffectedBookings.html.slim')
    scope:
      trainerAvailability: '='
